var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefualtArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 63,
    viewBox: "0 0 246 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.527 0.150056C245.996 0.440917 246.141 1.0573 245.85 1.52679C214.499 52.1313 117.176 94.8147 4.37743 30.5633L10.2201 38.9839C10.535 39.4376 10.4224 40.0607 9.96862 40.3755C9.51487 40.6904 8.8918 40.5778 8.57696 40.124L0.178406 28.0199C-0.0421631 27.702 -0.0595597 27.2854 0.133739 26.9503C0.327038 26.6151 0.696342 26.4215 1.08196 26.4532L17.437 27.7981C17.9875 27.8434 18.397 28.3263 18.3517 28.8767C18.3064 29.4271 17.8235 29.8366 17.2731 29.7914L5.34044 28.8101C117.348 92.6285 213.442 50.0402 244.15 0.473487C244.441 0.0039998 245.057 -0.140805 245.527 0.150056Z",
    fill: "#32A4BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefualtArrow);
export default __webpack_public_path__ + "static/media/defualtArrow.67de7fc2f97c6574229c125ce5a9eea7.svg";
export { ForwardRef as ReactComponent };